/**
 * 订单中心请求
 */
import request from '@/utils/http';

const isEsPage = () => location.hash.includes('/order-center-es');

// 基础数据商品选择
export const getSearchByMaterial = (params) => {
    return request({
        url: `/api-mdm/cdCommonMaterial/searchByMaterial`,
        method: 'get',
        params
    });
};
// 根据客户查询客户组
export const getGoodsGroup = (params) => {
    return request({
        url: `/api-mdm/cdOwnerGroupDetail/searchByOwnerCode`,
        method: 'get',
        params
    });
};
// 基础数据带客户组选择商品
export const searchByMaterialDto = (data) => {
    return request({
        url: `/api-mdm/cdCommonMaterial/searchByMaterialDto`,
        method: 'post',
        data
    });
};
// 基础数据带客户组选择商品(支持规格包装和单位字段)
export const searchByMaterialBaseData = (data) => {
    return request({
        url: `/api-mdm/searchByMaterialDto`,
        method: 'post',
        data
    });
};
// 根据条件查询配送规则列表
export const getCustomerOrderInfos = (params) => {
    if (isEsPage()) {
        params.searchType = 'ES';
    }
    return request({
        url: `/api-otp/customerOrderInfos`,
        method: 'get',
        params
    })
};

// 根据条件查询总数量
export const getTotalCounts = (params) => {
    if (isEsPage()) {
        params.searchType = 'ES';
    }
    return request({
        noProgress: true,
        url: `/api-otp/customerOrderInfosCount`,
        method: 'get',
        params
    });
};

// 订单中心新增修改
export const addOrUpdateCustomerOrderInfo = (data) => {
    return request({
        url: `/api-otp/converged/addOrUpdateCustomerOrderInfo`,
        method: 'post',
        data
    });
};
// 订单中心地址修改
export const updateCustomerAddress = (data) => {
    return request({
        url: `/api-otp/converged/updateCustomerAddress`,
        method: 'post',
        data
    });
};
// 订单中心地址查询地址
export const getCustomerAddress = (params) => {
    return request({
        url: `/api-otp/customerOrderAddresss/findByOrderNo`,
        method: 'get',
        params
    });
};

// 订单中心地址查询地址(带系统建议)
export const searchAndRecommendAddress = (params) => {
    return request({
        url: `/api-otp/searchAndRecommendAddress`,
        method: 'get',
        params
    });
};

// 订单中心修改查询
export const getCustomerOrderInfo = (params, id) => {
    return request({
        url: `/api-otp/converged/getCustomerOrderInfo/${id}`,
        method: 'get',
        params
    }).then(res=>{
        if(res.data&&res.data.itemsExt){
            res.data.items = res.data.itemsExt
        }
        return res
    });
};

// 订单中心详情
export const getOrderDetail = (params) => {
    return request({
        url: `/api-otp/converged/orderAndTaskDetails`,
        method: 'get',
        params
    });
};

// 订单路由
export const resInfos = (params) => {
    return request({
        url: `/api-otp/orderTraces`,
        method: 'get',
        params
    });
};
// LWMS2B的库存查询接口
export const searchTFWarehouse = (data) => {
    return request({
        url: `/api-otp/separateWarehouse/searchTF`,
        method: 'post',
        data
    });
};
// 订单审核
export const orderVrify = (data) => {
    return request({
        url: `/api-otp/order/verify`,
        method: 'put',
        data
    });
};

// 取消订单审核
export const cancelExamine = (data) => {
    return request({
        url: `/api-otp/converged/batchCancelFlow`,
        method: 'post',
        data
    });
};

// 获取云仓改仓地址
export const getCloudWhAddress = (params) => {
    return request({
        url: `/api-otp/searchWhsByOrderNo`,
        method: 'get',
        params
    });
};

// 云仓改仓
export const updateCloudWhAddress = (data) => {
    return request({
        url: `/api-otp/updateYcReceiveAddress`,
        method: 'post',
        data
    });
};

// 订单复制
export const copyOrEditCustomerOrder = (params) => {
    return request({
        url: `/api-otp/converged/copyOrEditCustomerOrder`,
        method: 'get',
        params
    }).then(res=>{
        console.log(res)
        if(res.data&&res.data.itemsExt){
            res.data.items = res.data.itemsExt
        }
        return res
    });
};

// 订单操作日志
export const getLog = (params) => {
    return request({
        url: `/api-otp/orderLogs`,
        method: 'get',
        params
    });
};

// 订单中心根据条件查询任务表列表
export const getTaskList = (params) => {
    return request({
        url: `/api-otp/taskItems`,
        method: 'get',
        params
    });
};

// 订单分仓查询
export const separateWarehouseSearch = (params) => {
    return request({
        url: `/api-otp/separateWarehouse/search`,
        method: 'get',
        params
    });
};

// 订单分仓确认
export const separateWarehouseConfirm = (data) => {
    return request({
        url: `/api-otp/separateWarehouse/confirm`,
        method: 'post',
        data
    });
};
// 取消分仓
export const separateWarehouseCancel = (data) => {
    return request({
        url: `/api-otp/separateWarehouse/cancel`,
        method: 'post',
        data
    });
};

// 视图建单
export const viewCreateOrder = (data) => {
    return request({
        url: `/api-otp/converged/viewCreateOrder`,
        method: 'post',
        data
    });
};

// 预约
export const appointment = (data) => {
    return request({
        url: `/api-otp/converged/appointment`,
        method: 'post',
        data
    });
};

// 冲销 /order/innerCancel
export const chargeOff = (data) => {
    return request({
        url: `/api-otp/order/innerCancel`,
        method: 'post',
        data
    });
};

// 关单查询明细列表
export const listCustomOrderItemsByOrderNos = (data) => {
    return request({
        url: `/api-otp/customerOrderInfo/listCustomOrderItemsByOrderNos`,
        method: 'post',
        data
    });
};
// 关单查询明细列表
export const batchCloseOrderListByOrderNos = (data) => {
    return request({
        url: `/api-otp/order/batchCloseOrderListByOrderNos`,
        method: 'post',
        data
    });
};

// 关单
export const closedCustomerOrderStatusMans = (data) => {
    return request({
        url: `/api-otp/order/closedCustomerOrderStatusMans`,
        method: 'post',
        data
    });
};

// 批量关单接口
export const batchClosedCustomerOrder = (data) => {
    return request({
        url: `/api-otp/order/batchClosedCustomerOrder`,
        method: 'post',
        data
    });
};

// 验证是否能关单
export const checkIsCanCloseOrder = (data) => {
    return request({
        url: `/api-otp/order/checkIsCanCloseOrder`,
        method: 'post',
        data
    });
};
// 点击修改，查询是否有子单
export const selectOne = (data) => {
    return request({
        url: '/api-otp/orderInfo/selectOne',
        method: 'post',
        data
    }).then(res => res);
};
// 拦截
export const routeIntercept = (data) => {
    return request({
        url: `/api-otp/routeIntercept`,
        method: 'post',
        data
    });
};
// 获取当前审核人信息
export const getProcessApproveInfo = (data) => {
    return request({
        url: `api-iflow/getProcessInfo`,
        method: 'post',
        data
    });
};
// Mip库存账务调账流程接口
export const workflowConfigs = (data) => {
    return request({
        url: `api-iflow/workflowConfigs`,
        method: 'post',
        data
    });
};
// 获取Mip的Url
export const mipIflowCreateDraft = (data) => {
    return request({
        url: `/api-otp/mipIflowCreateDraft`,
        method: 'post',
        data
    });
};
// 提交mip流程
export const createProcess = (data) => {
    return request({
        url: `/api-iflow/approveProcess?tenantCode=${data.tenantCode}&appCode=${data.currentApplicationCode}`,
        method: 'post',
        data
    }).then(res => res);
};
// 查询有没有mip流程
export const mipExecutionLogs = (data) => {
    return request({
        url: '/api-otp/mipExecutionLogs',
        method: 'post',
        data
    }).then(res => res);
};
// 新增流程表单
export const createMipForm = (data) => {
    return request({
        url: '/api-otp/mipForm',
        method: 'post',
        data
    }).then(res => res);
};
// 流程表单查询
export const getMipForm = (params) => {
    return request({
        url: '/api-otp/mipForm/selectOne',
        method: 'get',
        params
    }).then(res => res);
};
// 新增流程表单
export const createMipFile = (data) => {
    return request({
        url: '/api-otp/mipFile/insertBatch',
        method: 'post',
        data
    }).then(res => res);
};
// 附件删除
export const delMipFile = (data) => {
    return request({
        url: `/api-otp/mipFile/${data}`,
        method: 'delete'
    }).then(res => res);
};
export const changeDistribution = (data) => {
    return request({
        url: '/api-otp/netRiDeliveryType',
        method: 'post',
        data
    }).then(res => res);
};
// 获取详细地址
export const searchCountryByHistory = (data) => {
    return request({
        url: '/anapi-oms/searchagg/gis/searchCountryByKeywords',
        method: 'post',
        data
    }).then(res => res);
};
// 模糊检索联系人
export const searchConcatList = (data) => {
    return request({
        url: '/api-dc/custom/contacts/oms/page',
        method: 'get',
        params: data
    }).then(res => res);
};
// 新增联系人
export const addContactsOms = (data) => {
    return request({
        url: '/api-dc/custom/contacts/oms/add',
        method: 'post',
        data
    }).then(res => res);
};
// 查询模糊订单接口
export const searchVagueOrderList = (params) => {
    return request({
        url: '/api-otp/vagueOrderSearch',
        method: 'get',
        params
    }).then(res => res);
};
// 批量关联模糊订单
export const relateVagueOrder = (data) => {
    return request({
        url: '/api-otp/vagueRelation',
        method: 'post',
        data
    }).then(res => res);
};

// 图片识别
export const getOcrCustomerOrder = (data) => {
    return request({
        url: `/api-otp/ocr/customer/order`,
        method: 'post',
        data
    });
};
// 客户商品编码获取
export const getCustomerItemCode = (data) => {
    return request({
        url: `/api-otp/ocr/customer/order/item/code`,
        method: 'post',
        data
    });
};
// 客户商品编码获取
export const checkPickUpCode = (data) => {
    return request({
        url: `/api-otp/checkPickUpCode`,
        method: 'post',
        data
    });
};
// 发送商品编码获取
export const sendPickUpCode = (order) => {
    return request({
        url: `/api-otp/sendPickUpCode?orderNo=${order}`,
        method: 'post'
    });
};

// 外部客户查询订单
// 根据条件查询配送规则列表
export const getExternalCustomerOrderInfos = (params) => {
    return request({
        url: `/api-otp/externalCustomerOrderInfos`,
        method: 'get',
        params
    });
};

// 根据条件查询总数量
export const getExternalTotalCounts = (params) => {
    return request({
        url: `/api-otp/externalCustomerOrderInfosCount`,
        method: 'get',
        params
    });
};

// 奇门异常订单推送
export const qimenExceptionOrderInfos = (data) => {
    return request({
        url: `/api-otp/converged/exceptionOrderInfos`,
        method: 'post',
        data
    });
};

// 单独处理DECODE_PDD_QIMEN_CUSTOMER数据字典
export const getRepeatableDictToMap = (params) => {
    return request({
        url: `/api-otp/getRepeatableDictToMap`,
        method: 'get',
        params
    });
};

// 获取签收状态
export const getPackageStatus = (data) => {
    return request({
        url: `/api-otp/reviseSign/packageStatus`,
        method: 'post',
        data
    });
};

// 改签-签收回传
export const confirmPackageStatus = (data) => {
    return request({
        url: `/api-otp/reviseSign/confirm`,
        method: 'post',
        data
    });
};
// 中转单生成运输任务
export const taskYsCreateAPI = (data) => {
    return request({
        url: '/api-otp/task/ys/create',
        method: 'post',
        data
    });
};
// 查询分仓详情
export const batchSeparateAPI = (data) => {
    return request({
        url: '/api-otp/batchSeparateWarehouse/search',
        method: 'post',
        data
    });
};
// 批量分仓
export const batchSeparateConfirmAPI = (data) => {
    return request({
        url: '/api-otp/batchSeparateWarehouse/confirm',
        method: 'post',
        data
    });
};
// 挂起
export const batchOrderPending = (data) => {
    return request({
        url: '/api-otp/converged/batchOrderPending',
        method: 'post',
        data
    });
};
// 取消挂起
export const batchCancelPending = (data) => {
    return request({
        url: '/api-otp/converged/batchCancelPending',
        method: 'post',
        data
    });
};
// 集拼多单查详情
export const listWarehouseByItemTaskNosAPI = (data) => {
    return request({
        url: '/api-otp/preposeTaskItems/listWarehouseByItemTaskNos',
        method: 'post',
        data
    });
};
// 订单中心多单分仓查详情
export const customerOrderItemAPI = (data) => {
    return request({
        url: '/api-otp/customerOrderItem/listWarehouseByItemOrderNos',
        method: 'post',
        data
    });
};
// 查商品库存
export const centerInvQueryAPI = (data) => {
    return request({
        url: '/api-otp/item/CenterInvQuery',
        method: 'post',
        data
    });
};
// 查已分仓数据
export const getSplitedOrderInfoNosAPI = (data) => {
    return request({
        url: '/api-otp/getSplitedOrderInfoItemsByParentOrderNos',
        method: 'post',
        data
    });
};
/** 查已分仓金额 */
export const deliveryAmountQueryAPI = (params) => {
    return request({
        url: '/api-otp/deliveryAmountQuery',
        method: 'get',
        params
    });
};
/** 获取安得批次ID** */
export const genIdAPI = (params={}) => {
    return request({
        url: '/api-otp/aiRecordInfo/genId',
        method: 'get',
        params
    });
};
